import { useCallback } from 'react';

import { useCompanySearch } from './useCompanySearch';

import { getTickerCellTemplate, getCurrencyISO } from '../../CustomCell/Ticker';

const wait = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const useTickerCellSearch = () => {
  const { searchCompany, getMatchingListing } = useCompanySearch();

  const search = useCallback(
    async (value) => {
      const [searchResults] = await Promise.all([
        searchCompany(value ?? ''),
        // Here we simulate a delay of at least 250ms to show the pending state
        // Algolia is fast and responds in ~200ms on avg
        // Without this delay, the cell will just flash the pending state
        wait(250),
      ]);
      const [matchingCompany] = searchResults;

      const listing = getMatchingListing(value, matchingCompany);

      if (!listing) {
        return getTickerCellTemplate({
          value,
          status: 'error',
          error: "Can't match to a company",
        });
      }

      const { exchangeCountryIso, name, uniqueSymbol } = listing;

      return getTickerCellTemplate({
        value,
        currencyISO: getCurrencyISO(exchangeCountryIso),
        name: name,
        uniqueSymbol: uniqueSymbol,
        status: 'success',
      });
    },
    [getMatchingListing, searchCompany]
  );

  return { search };
};
